'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'comment-plus';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4b2';
var svgPathData = 'M256 32C114.7 32 .0281 125.1 .0281 240c0 47.63 19.92 91.25 52.91 126.3c-14.88 39.5-45.87 72.88-46.37 73.25c-6.621 7-8.373 17.25-4.623 26C5.816 474.3 14.38 480 24 480c61.49 0 109.1-25.75 139.1-46.25C192.1 442.8 223.3 448 256 448c141.4 0 255.1-93.13 255.1-208S397.4 32 256 32zM256 416c-28.24 0-56.24-4.25-83.23-12.75c-9.516-3.068-19.92-1.461-28.07 4.338c-22.99 16.25-58.55 35.29-102.7 39.66c12-15.12 29.75-40.5 40.74-69.63l.1328-.3398c4.281-11.27 1.789-23.1-6.43-32.82C47.51 313.1 32.06 277.6 32.06 240c0-97 100.5-176 223.1-176c123.5 0 223.1 79 223.1 176S379.5 416 256 416zM336 224h-64V159.1C272 151.2 264.8 144 256 144S240 151.2 240 159.1V224h-64C167.2 224 160 231.2 160 240c0 8.834 7.156 15.1 16 15.1h64v64C240 328.8 247.2 336 256 336c8.836 0 16-7.16 16-15.1V255.1h64c8.84 0 16-7.16 16-15.1S344.8 224 336 224z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCommentPlus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faCommentPlus.js
// module id = 8Z17
// module chunks = 0